module.exports = __webpack_public_path__ + "static/media/client-logo-6.140ed58a.jpg";